/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { PAGE_ACTION, PAGE_PERMISSION } from '../../../../app/modules/roles/constant/role-default'
import { DEMO_SECTIONS } from '../../../../app/modules/demo/demoMode'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/portfolio-overview'
        title='Portfolio Overview'
        fontIcon='bi-collection'
        icon='/media/icons/duotune/graphs/gra008.svg'
        pagePermission={[`${PAGE_PERMISSION.PortfolioOverview}.${PAGE_ACTION.View}`]}
      />
      <AsideMenuItem
        to="/dashboard"
        title="Dashboard"
        fontIcon="bi-grid"
        icon="/media/icons/tims/menu-dashboard.svg"
        pagePermission={[
          PAGE_PERMISSION.Dashboard,
          `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_DASHBOARD}
      />

      <AsideMenuItem
        to="/variation-assessments"
        title="Variations"
        icon="/media/icons/tims/arrow-left-right.svg"
        pagePermission={[
          PAGE_PERMISSION.Reports_VariationAssessments,
          `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_REPORTS_VARIATION}
      />

      <AsideMenuItem
        to="/progress-claim"
        title="Progress Claim"
        icon="/media/icons/tims/bars-progress.svg"
        pagePermission={[
          PAGE_PERMISSION.Reports_ProgressClaim,
          `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_REPORTS_PROGRESS}
      />

      <AsideMenuItem
        to="/pcg-report"
        title="PCG Report"
        icon="/media/icons/tims/menu-reports.svg"
        pagePermission={[
          PAGE_PERMISSION.Reports_PcgReport,
          `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_REPORTS_PCG}
      />

      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>

      <AsideMenuItem
        to="/project-details"
        title="Project Details"
        fontIcon="bi-clipboard2-data"
        icon="/media/icons/tims/menu-product.svg"
        pagePermission={[
          PAGE_PERMISSION.Project_Details,
          `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_PROJECT_DETAILS}
      />

      <AsideMenuItem
        to="/project-setup"
        title="Project Setup"
        fontIcon="bi-diagram-3"
        icon="/media/icons/tims/menu-product.svg"
        pagePermission={[
          PAGE_PERMISSION.Project_SetupWizard,
          `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_PROJECT_SETUP}
      />

      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>

      <AsideMenuItemWithSub
        to="#"
        activePaths={['/user', '/role']}
        title="Administration"
        fontIcon="bi-chat-left"
        icon="/media/icons/tims/menu-administration.svg"
        pagePermissions={[
          PAGE_PERMISSION.Users,
          `${PAGE_PERMISSION.Users}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Delete}`,
          PAGE_PERMISSION.Roles,
          `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.View}`,
          `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Create}`,
          `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Update}`,
          `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Delete}`
        ]}
        demoSectionId={DEMO_SECTIONS.MENU_ADMINISTRATION}
      >
        <AsideMenuItem
          to="/user"
          title={intl.formatMessage({ id: 'MENU.USERS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-users.svg"
          pagePermission={[
            PAGE_PERMISSION.Users,
            `${PAGE_PERMISSION.Users}.${PAGE_ACTION.View}`,
            `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Create}`,
            `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Update}`,
            `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Delete}`
          ]}
          demoSectionId={DEMO_SECTIONS.MENU_ADMIN_USERS}
        />

        <AsideMenuItem
          to="/role"
          title={intl.formatMessage({ id: 'MENU.ROLES' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-roles.svg"
          pagePermission={[
            PAGE_PERMISSION.Roles,
            `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.View}`,
            `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Create}`,
            `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Update}`,
            `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Delete}`
          ]}
          demoSectionId={DEMO_SECTIONS.MENU_ADMIN_ROLES}
        />
      </AsideMenuItemWithSub>
    </>
  )
}

